export default __webpack_public_path__ + "static/media/Mask Group 70.d23d9713.png";